import { useState } from 'react'
import { API_BASE_URL } from 'config/api'
import axios from 'axios'
import { Toast } from 'components/Products/components/Toast'
import { Cookies } from 'react-cookie'

export const OrderNoteForm = ({ cart }: { cart?: any }) => {
  const [note, setNote] = useState(cart?.note || '')
  const [noteLoading, setNoteLoading] = useState(false)
  const [noteError, setNoteError] = useState<string | null>(null)
  const [toastMessage, setToastMessage] = useState<string | null>(null)
  const cookies = new Cookies()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setNoteLoading(true)
    setNoteError(null)
    try {
      const token = cookies.get('@bookstory-auth-token')
      const authToken = token?.user?.authToken
      let userToken = authToken?.accessToken

      await axios.put(
        `${API_BASE_URL}/orders/${cart.id}/add-note`,
        { note },
        { headers: { Authorization: 'bearer ' + userToken } },
      )
      cart.notes = note
      localStorage.setItem('cart', JSON.stringify(cart))
      setToastMessage('یادداشت شما با موفقیت اضافه شد.')
    } catch (err) {
      setNoteError('خطا در ثبت یادداشت سفارش')
    } finally {
      setNoteLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className='mt-6 flex flex-col items-start'>
      {toastMessage && (
        <Toast message={toastMessage} onDismiss={() => setToastMessage(null)} />
      )}
      <h3 className='text-lg font-semibold mb-2' style={{ color: 'var(--text-primary)' }}>
        یادداشتی برای سفارش خود دارید اضافه کنید. (اختیاری)
      </h3>
      <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        className='input-theme w-full 2xl:w-3/4 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition'
        rows={4}
        placeholder='یادداشتی برای سفارش خود دارید اضافه کنید...'
        required
      />
      <button
        type='submit'
        disabled={note.length === 0}
        className={`mt-4 w-full md:w-auto px-6 py-3 font-semibold rounded-lg focus:outline-none ${
          note.length === 0
            ? 'hover:cursor-default'
            : 'text-white focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105'
        }`}
        style={
          note.length === 0
            ? { backgroundColor: 'var(--bg-tertiary)', color: 'var(--text-tertiary)' }
            : { backgroundColor: 'var(--accent-primary)' }
        }
      >
        {noteLoading ? 'در حال ذخیره...' : 'ذخیره یادداشت'}
      </button>
      {noteError && <div className='text-red-200 mt-2'>{noteError}</div>}
    </form>
  )
}
